import React, { useState, useEffect } from "react";
import { FiX, FiMenu, FiRefreshCw } from "react-icons/fi";
import Scrollspy from "react-scrollspy";
import { ApiKickAll, ApiTransCheck } from "../../modules/api/GameApi";
import NumberFormat from "react-number-format";
const Header = (props) => {
  const [member, setMember] = useState({ u: "-", w: 0 });
  const { color = "default-color" } = props;
  useEffect(() => {
    window.addEventListener("load", function () {
      console.log("All assets are loaded");
    });
    window.addEventListener("scroll", function () {
      var value = window.scrollY;
      if (value > 100) {
        document.querySelector(".header--fixed").classList.add("sticky");
      } else {
        document.querySelector(".header--fixed").classList.remove("sticky");
      }
    });

    var elements = document.querySelectorAll(".has-droupdown > a");
    for (var i in elements) {
      if (elements.hasOwnProperty(i)) {
        elements[i].onclick = function () {
          this.parentElement
            .querySelector(".submenu")
            .classList.toggle("active");
          this.classList.toggle("open");
        };
      }
    }
    // check permission
    _checkTransaction();
  }, []);
  const _checkTransaction = async () => {
    let localTransId = await localStorage.getItem("transId");
    if (localTransId) {
      let response = await ApiTransCheck(localTransId);
      if (response) {
        let apiReturn = response.data.data;
        if (apiReturn !== null && apiReturn[0] !== null) {
          if (apiReturn[0].TCC_STATUS === "01") {
            if (!apiReturn[0].TCC_MEMBER_WALLET_CENTER)
              apiReturn[0].TCC_MEMBER_WALLET_CENTER = 0;
            if (!apiReturn[0].TCC_MEMBER_WALLET_GAME)
              apiReturn[0].TCC_MEMBER_WALLET_GAME = 0;

            setMember({
              u: apiReturn[0].TCC_MEMBER_USERNAME,
              w:
                parseFloat(apiReturn[0].TCC_MEMBER_WALLET_CENTER) +
                parseFloat(apiReturn[0].TCC_MEMBER_WALLET_GAME),
            });
            await localStorage.setItem("transId", localTransId);
            // setIsChecked(true);
          } else {
            window.location.replace(apiReturn.EXPIRED_REDIRECT_URL);
          }
        } else {
          // setIsChecked(false);
          window.location.replace("/error/000");
        }
      }
    } else {
      //  window.location.replace("/error/000");
      //
    }
    // console.log(localTransId);
    // console.log(member);
  };
  const _onMenuTrigger = () => {
    document.querySelector(".header-wrapper").classList.toggle("menu-open");
  };

  const _onCLoseMenuTrigger = () => {
    document.querySelector(".header-wrapper").classList.remove("menu-open");
  };

  const _onWalletRefresh = () => {
    let localTransId = localStorage.getItem("transId");
    ApiKickAll(localTransId).then(({ data }) => {
      window.location.reload();
    });
  };

  // console.log(member);
  return (
    <header className={`header-area formobile-menu header--fixed ${color}`}>
      <div className="header-wrapper">
        <div className="header-left d-flex align-items-center">
          <div className="logo"></div>
          <nav className="mainmenunav d-lg-block ml--50">
            <Scrollspy
              className="mainmenu"
              items={["Home", "GameLive", "GameSlot", "GameCard"]}
              currentClassName="is-current"
              offset={-200}
            >
              <li>
                <a href="/">หน้าหลัก</a>
              </li>
              <li>
                <a href="/g/live">คาสิโนสด</a>
              </li>
              <li>
                <a href="/g/slot">เกมส์สล็อต</a>
              </li>
              <li>
                <a href="/g/card">เกมส์ไพ่</a>
              </li>
            </Scrollspy>
          </nav>
        </div>
        <div className="header-right">
          <div className="social-share-inner text-white mr--20">
            {member.u.toUpperCase()}
          </div>
          <div className="header-btn">
            <button
              className="rn-button-style--2 btn-solid"
              onClick={() => {
                _onWalletRefresh();
              }}
            >
              <NumberFormat
                value={member.w}
                displayType={"text"}
                thousandSeparator={true}
                fixedDecimalScale={true}
                decimalScale={2}
                prefix={"THB "}
              />
              {"  "}
              <FiRefreshCw />
            </button>
          </div>
          {/* Start Humberger Menu  */}
          <div className="humberger-menu d-block d-lg-none pl--20">
            <span
              onClick={() => {
                _onMenuTrigger();
              }}
              className="menutrigger text-white"
            >
              <FiMenu />
            </span>
          </div>
          {/* End Humberger Menu  */}
          <div className="close-menu d-block d-lg-none">
            <span
              onClick={() => {
                _onCLoseMenuTrigger();
              }}
              className="closeTrigger"
            >
              <FiX />
            </span>
          </div>
        </div>
      </div>
    </header>
  );
};
export default Header;
